<div class="tab-body" *ngIf="permissionData$| async as permissionData">
  <div *ngIf="this.RORequired" class="container header">
    <div class="personnel-content">
      <mat-icon class="icon">warning</mat-icon>Please select the approving
      personnel for your project budgets
    </div>
    <button (click)="selectPersonnelClick(); budgetSummaryPanel.expanded = true" class="personnel-btn" mat-flat-button>
      Select personnel
    </button>
  </div>

  <mat-accordion multi class="tab-body" togglePosition="before">
    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title> Items to request </mat-panel-title>
      </mat-expansion-panel-header>
      <app-item-list (itemCost)="sendFinalItemCost($event)" [isReadOnly]="isReadOnly"></app-item-list>
    </mat-expansion-panel>

    <app-capital-budget-requirement-list></app-capital-budget-requirement-list>


    <mat-expansion-panel id="budgetSummaryPanel" #budgetSummaryPanel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title>Budget summary</mat-panel-title>
      </mat-expansion-panel-header>
      <app-budget-summary id="budgetSummaryTable" #budgetSummaryTable [isReadOnly]="isReadOnly"></app-budget-summary>
    </mat-expansion-panel>

    <mat-expansion-panel expanded="true">
      <mat-expansion-panel-header>
        <mat-panel-title> Vendors to source </mat-panel-title>
      </mat-expansion-panel-header>
      <app-add-vendor [recieved]="recieveCost" [isDocReadOnly]="isReadOnly" [isLocked]="isLocked"></app-add-vendor>
    </mat-expansion-panel>
  </mat-accordion>
</div>